var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-finish-list" },
    [
      _c(
        "div",
        { staticClass: "search-bar" },
        [
          _c("el-input", {
            staticStyle: { width: "300px", "margin-right": "10px" },
            attrs: { placeholder: "请输入名称搜索", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.loadConfig($event)
              },
            },
            model: {
              value: _vm.searchName,
              callback: function ($$v) {
                _vm.searchName = $$v
              },
              expression: "searchName",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.loadConfig } },
            [_vm._v("搜索")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
            [_vm._v("新增配置")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.tableData, border: "" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "title", label: "名称", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "类型", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c("span", [_vm._v("领券广场")])
                          : scope.row.type === 2
                          ? _c("span", [_vm._v("好物推荐")])
                          : scope.row.type === 3
                          ? _c("span", [_vm._v("gaga门店")])
                          : _c("span", [_vm._v("未知类型")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "图片", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "image-cell",
                            on: {
                              click: function ($event) {
                                return _vm.handleImagePreview(scope.row)
                              },
                            },
                          },
                          [
                            _vm.getImageUrl(scope.row.imageUrl)
                              ? _c("img", {
                                  staticClass: "table-image",
                                  attrs: {
                                    src: _vm.getImageUrl(scope.row.imageUrl),
                                    alt: "配置图片",
                                  },
                                })
                              : _c("div", { staticClass: "no-image" }, [
                                  _vm._v("暂无图片"),
                                ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "redirectUrl",
                  label: "跳转地址",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getPageName(scope.row.redirectUrl))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "排序", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " + _vm._s(scope.row.sort) + "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleToggleEnable(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.enable,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "enable", $$v)
                            },
                            expression: "scope.row.enable",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "200", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入名称" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "上传图片", prop: "imageUrl" } },
                [
                  _c("div", { staticClass: "image-uploader" }, [
                    _c(
                      "div",
                      {
                        staticClass: "image-preview",
                        on: { click: _vm.triggerSelect },
                      },
                      [
                        _vm.getImageUrl(_vm.form.imageUrl)
                          ? _c("img", {
                              staticClass: "preview-img",
                              attrs: {
                                src: _vm.getImageUrl(_vm.form.imageUrl),
                                alt: "配置图片预览",
                              },
                            })
                          : _c("div", { staticClass: "image-placeholder" }, [
                              _c("i", {
                                staticClass: "el-icon-picture-outline",
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "placeholder-text" }, [
                                _vm._v("点击上传图片"),
                              ]),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      staticStyle: { display: "none" },
                      attrs: { type: "file", accept: "image/*" },
                      on: { change: _vm.handleFileChange },
                    }),
                    _vm._v(" "),
                    _vm.form.imageUrl
                      ? _c(
                          "div",
                          { staticClass: "uploader-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: { click: _vm.removeImage },
                              },
                              [_vm._v("移除")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳转地址", prop: "redirectUrl" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择跳转页面", filterable: "" },
                      model: {
                        value: _vm.form.redirectUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "redirectUrl", $$v)
                        },
                        expression: "form.redirectUrl",
                      },
                    },
                    _vm._l(_vm.pageList, function (page) {
                      return _c("el-option", {
                        key: page.pageUrl,
                        attrs: { label: page.pageName, value: page.pageUrl },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择类型" },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "领券广场", value: 1 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "好物推荐", value: 2 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "gaga门店", value: 3 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 999, size: "small" },
                    on: { change: _vm.handleFormSortChange },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览图片",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览图片" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }